<template>
  <div class="an-page">
    <ul>
      <li>
        <p>
          <span>头像</span>
          <img :src="avatar" alt />
        </p>
        <Upload
          :action="baseUrl+'/api/public/img'"
          :show-upload-list="false"
          :headers="header"
          :on-success="successHanlder"
          :format="['jpg','jpeg','png','gif']"
        >修改</Upload>
        <!-- <font @click="upload">修改</font> -->
      </li>
      <li>
        <p>
          <span>密码</span>
          <span>*********</span>
        </p>
        <font @click="beginChnagePassword">修改</font>
      </li>
    </ul>
    <Modal
      :mask-closable="false"
      class="vertical-center-modal"
      v-model="moveModal"
      @on-cancel="cancel"
      title="修改密码"
      width="450"
    >
      <Form
        ref="formValidate"
        :rules="ruleValidate"
        :model="formValidate"
        style="width: 300px; margin: 0 auto;"
      >
        <FormItem prop="oldPwd">
          <Input type="password" v-model="formValidate.oldPwd" placeholder="旧密码" clearable />
        </FormItem>
        <FormItem prop="newPwd">
          <Input type="password" v-model="formValidate.newPwd" placeholder="新密码" clearable />
        </FormItem>
        <FormItem prop="confirmPwd">
          <Input type="password" v-model="formValidate.confirmPwd" placeholder="确认新密码" clearable />
        </FormItem>
      </Form>
      <div slot="footer">
        <Button @click="cancel">取消</Button>
        <Button type="primary" @click="confirm()">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
const buildConfig = require("../../build/" + process.env.BUILD_ENV + ".js");
export default {
  name: "AccountNew",
  data() {
    const validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        if (this.formValidate.confirmPwd !== "") {
          this.$refs.formValidate.validateField("confirmPwd");
        }
        callback();
      }
    };
    const validatePassCheck = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入再次密码"));
      } else if (value !== this.formValidate.newPwd) {
        callback(new Error("两次输入不一致！"));
      } else {
        callback();
      }
    };
    return {
      avatar: "",
      baseUrl: buildConfig.BASE_URL,
      header: {
        Authorization: "Bearer " + localStorage.adminToken
      },
      moveModal: false,
      ruleValidate: {
        oldPwd: [
          {
            required: true,
            message: "请输入",
            trigger: "blur"
          }
        ],
        newPwd: [{ validator: validatePass, trigger: "blur" }],
        confirmPwd: [{ validator: validatePassCheck, trigger: "blur" }]
      },
      formValidate: {
        oldPwd: "",
        newPwd: "",
        confirmPwd: "",
        init: function() {
          this.oldPwd = "";
          this.newPwd = "";
          this.confirmPwd = "";
        }
      }
    };
  },
  created() {
    this.getUserInfo();
  },
  methods: {
    async getUserInfo() {
      let data = await this.$http.get(`/api/getLoginUser`);
      this.avatar = data.avatar;
    },
    async successHanlder(response) {
      await this.$http.put(`/api/edit/adminUser/avatar`, {
        avatar: response.data.path
      });
      await this.getUserInfo();
      this.$store.commit("setAvatar", this.avatar);
    },
    beginChnagePassword() {
      this.moveModal = true;
      this.formValidate.oldPwd = "";
      this.formValidate.newPwd = "";
      this.formValidate.confirmPwd = "";
    },
    confirm() {
      this.$refs.formValidate.validate(val => {
        if (val) {
          this.$http
            .put(`/api/edit/adminUser/password`, this.formValidate)
            .then(() => {
              this.moveModal = false;
              this.getUserInfo();
              this.formValidate.init();
            });
        } else {
          this.$Message.error("输入有误！");
        }
      });
    },
    cancel() {
      this.moveModal = false;
      this.formValidate.init();
    }
  }
};
</script>

<style lang='scss' scoped>
.an-page {
  .ivu-form-item-content {
    width: 300px;
  }
  ul {
    margin: 20px;
    border-top: 1px solid #f8f8f8;
    li {
      border: 1px solid #f8f8f8;
      border-top: 0;
      display: flex;
      align-items: center;
      font-size: 16px;
      font-family: "微软雅黑";
      height: 90px;
      p {
        flex: 1;
        display: flex;
        align-items: center;
      }
      span {
        padding-left: 30px;
      }
      img {
        max-width: 54px;
        margin-left: 30px;
      }
      font {
        width: 60px;
        color: #2d8cf0;
        text-align: center;
        cursor: pointer;
      }
      .ivu-upload {
        width: 60px;
        color: #2d8cf0;
        text-align: center;
        cursor: pointer;
      }
    }
  }
}
</style>
